import {
    WEBCHAT,
} from 'Constant';

/**
 * export namespace
 */
export const NAMESPACE = 'REFRESH';
/**
 * REFRESH_WEBCHAT_MESSAGE
 */
export const REFRESH_WEBCHAT = `${WEBCHAT}/${NAMESPACE}/REFRESH_WEBCHAT_MESSAGE`;

/**
 * REFRESH_WEBCHAT_MESSAGE_SUCCESS
 */
export const REFRESH_WEBCHAT_SUCCESS = `${WEBCHAT}/${NAMESPACE}/REFRESH_WEBCHAT_MESSAGE_SUCCESS`;

/**
 * REFRESH_WEBCHAT_MESSAGE_FAILED
 */
export const REFRESH_WEBCHAT_FAILED = `${WEBCHAT}/${NAMESPACE}/REFRESH_WEBCHAT_MESSAGE_FAILED`;

/**
 * HAND_OVER_TO_AGENT
 */
 export const HAND_OVER_TO_AGENT = `${WEBCHAT}/${NAMESPACE}/HAND_OVER_TO_AGENT`;
